import GeneratedURLCard from "./GeneratedURLCard";
  
  export default GeneratedURLCard;
  